<template lang="pug">
.FormSubscribeNewsletter.form-row
  .is-h3__title.subheading Subscribe to the AcreTrader Newsletter
  form(
    ref="form"
  )
    BaseSpinner(
      :value="model.$loading",
      transparent,
      color="#fff"
    )
    BaseFormGroup(
      name="email",
      label="Email",
      placeholder="name@domain.com"
      :model="model",
      id="subscribe_email"
    )
    v-btn(
      type="submit",
      @click.prevent="$_form_send"
      color="secondary"
    ) Subscribe
</template>

<script>
import { mapGetters } from 'vuex';
import SubscribeNewsletterModel from 'Models/SubscribeNewsletterModel';
import formHubspotMixin from 'Mixins/formHubspotMixin';
import formHandlingMixin from 'Helpers/mixins/formHandlingMixin';

export default {
  name: 'FormSubscribeNewsletter',
  components: {
    BaseFormGroup: () => import(/* webpackChunkGroup: 'BaseFormGroup' */ 'Components/Base/BaseFormGroup'),
  },
  mixins: [formHandlingMixin, formHubspotMixin],
  data() {
    return {
      $_form_showServeErrorAsToaster: true,
      model: new SubscribeNewsletterModel(),
    };
  },
  computed: {
    ...mapGetters('profile', [
      'profile',
    ]),
  },
  watch: {
    profile: {
      handler: 'copyFromProfile',
      immediate: true,
    },
  },
  methods: {
    copyFromProfile() {
      if (Object.keys(this.profile).length) {
        this.model.$setAll(this.profile);
      } else {
        this.model.$reset();
      }
    },
  },
};
</script>

<style lang="sass" scoped>
@import '~Styles/_variables'
.form-row
  .is-h3__title
    color: $text_gray
    margin-bottom: 20px
    @media screen and (max-width: 576px)
      margin-bottom: 15px
  form
    display: flex
    ::v-deep .input-label
      display: none
    ::v-deep .base-form-group
      flex: 1
      .v-input
        background-color: transparent !important
      fieldset
        top: -5px
        border-bottom-right-radius: 0
        border-top-right-radius: 0
        border-right: none
      .v-input__slot
        background-color: #fff !important
        border-bottom-left-radius: 5px
        border-top-left-radius: 5px
        border-bottom-right-radius: 0
        border-top-right-radius: 0
      .v-messages.theme--light
        background-color: transparent !important
    .v-btn
      position: relative
      left: -4px
      border-top-left-radius: 0
      border-bottom-left-radius: 0
</style>
